import React, { useState } from 'react';
import { RATING } from '@/constants/testIds';
import StarRating from '@/components/StarRating';

export default function RatingModal({ open, booking, onClose, onSubmit }) {
  const [stars, setStars] = useState(5);
  const [comment, setComment] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  if (!open || !booking) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!comment.trim()) {
      setError('Please share a brief comment');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      await onSubmit({ stars, comment, booking_id: booking.id, consultant_email: booking.consultant_email });
      setStars(5);
      setComment('');
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to submit rating');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-6">
      <div className="bg-white rounded-sm max-w-lg w-full p-8">
        <h2 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Outfit' }}>Rate Your Consultation</h2>
        <p className="text-sm text-slate-600 mb-6">
          {booking.service_type.replace('_', ' ')} with {booking.consultant_email}
        </p>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-sm font-medium text-black mb-3">Your Rating</label>
            <StarRating
              value={stars}
              size="xl"
              interactive
              onChange={setStars}
              testIdPrefix={RATING.starButton}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-black mb-2">Your Review</label>
            <textarea
              data-testid={RATING.commentInput}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              className="w-full px-4 py-2 border border-slate-300 rounded-sm focus:ring-2 focus:ring-blue-600"
              rows="4"
              placeholder="Share your experience..."
              required
            />
          </div>

          {error && (
            <div className="p-3 bg-red-50 border border-red-200 rounded-sm text-sm text-red-800">
              {error}
            </div>
          )}

          <div className="flex gap-4 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-6 py-3 border border-slate-300 rounded-sm hover:bg-slate-50 transition-all"
            >
              Cancel
            </button>
            <button
              data-testid={RATING.submitButton}
              type="submit"
              disabled={submitting}
              className="flex-1 px-6 py-3 bg-black text-white rounded-sm hover:bg-slate-800 transition-all disabled:opacity-50"
            >
              {submitting ? 'Submitting...' : 'Submit Review'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
